export const textStyles = {
    text: {
      color: 'white',
      fontFamily: 'Inter, sans-serif',
    }
}